<template>
  <div id="trqansaction" v-if="showWindow">    
    <vs-popup classContent="popup-example" title="Table setup" :active.sync="popUps.popupShowActive">
        <div class="vx-row mb-4">
            <div class="vx-col w-1/4" v-for="(column,index) in params" :key="index" style="padding: 5px">
                <vs-button class="ml-auto w-full" color="primary" :type="getType(index)" @click="showHideColumn(index)">{{index}}</vs-button> 
            </div>
        </div>
    </vs-popup> 
    <vs-popup classContent="popup-example" title="Complete manual" :active.sync="popUps.popupActive">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Amount" v-model="amount" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Value out" v-model="params.value_out" />
        </div>
      </div>
       <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Ext ref" v-model="params.ext_ref" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Commission" v-model="params.commission" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Send code" v-model="params.send_code" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('complete-manual')" color="primary" type="filled">Save</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Settle" :active.sync="popUps.popupSettleActive">
      
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full send-wallet-val-input"   disabled label="Value out" v-model="params.value_out" />
        </div>
      </div>
       
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('send-wallet')" color="primary" type="filled">SEND</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Complete deposit" :active.sync="popUps.popupSellActive">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Amount" v-model="amount" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('complete-deposit')" color="primary" type="filled">Save</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Cancel order" :active.sync="popUps.popupCancelOrder">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <!--<vs-input class="inputx w-full" label="Reference" v-model="params.reference1" />-->
          <p>Are you sure you want to cancel order?</p>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('cancel-order')" color="primary" type="filled">Yes</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Decline order" :active.sync="popUps.popupDeclineActive">
      <h3>Are you sure you want to decline this order?</h3>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('decline')" color="primary" type="filled">Yes</vs-button>
         
        </div>
      </div>
       
    </vs-popup>
    <vs-popup classContent="popup-example" title="Capture order" :active.sync="popUps.popupCaptureActive">
      <h3>Are you sure you want to capture this order?</h3>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('capture')" color="primary" type="filled">Yes</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Approve pending wire" :active.sync="popUps.popupApproveOrder">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Amount" v-model="amount" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('approve')" color="primary" type="filled">Approve</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Approve send crypto" :active.sync="popUps.popupSendCrypto">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          {{params.reference}}
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('sendCrypto')" color="primary" type="filled">Send</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Update rate" :active.sync="popUps.popupUpdateRate">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Wallet" v-model="wallet" />
        </div>
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Amount" v-model="amount_approved" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('updateRate')" color="primary" type="filled">Update</vs-button>
        </div>
      </div>
    </vs-popup>
    <div class="flex flex-wrap justify-between items-center">
      <vs-button color="primary" class="inline-block" type="flat" @click="popUps.popupShowActive=true">Fields settings</vs-button>
      <draggable v-model="fieldsData" @start="drag=true" @end="saveSort()" class="vx-row mb-4" >
          <div class="vx-row mb-4" v-for="(item) in fieldsData" :key="item.order" v-show="item.show && item.name!=='timestamp'">
              <div class="vx-col w-full">
                {{item.name}} <vs-button radius color="primary" class="inline-block" type="flat"  icon="content_copy" @click="copyToClipBoard(item.name)"></vs-button>
                <br />
                <vs-input class="inputx inline-block" size="normal" v-model="params[item.name]"/>&nbsp;
              </div>
          </div>      
        </draggable>
    </div>
    <div class="flex flex-wrap justify-between items-center">
      
      <div class="vx-row mb-12 w-full">
          Wallet: {{params.wallet}}
      </div>
      <div class="vx-row mb-12">
        <div class="vx-col" v-if="buttons.completeManual && isUserAllowedBtn">
          <vs-button @click="popUps.popupActive=true" color="primary" class="ml-auto w-full" type="filled">Complete manual</vs-button>
        </div>
        <div class="vx-col" v-if="buttons.settle && isUserAllowedBtn">
          <vs-button @click="popUps.popupSettleActive=true" color="primary" class="ml-auto w-full" type="filled">Settle</vs-button>
        </div>
         <div class="vx-col" v-if="buttons.cancelOrder && isUserAllowedBtn"> 
          <vs-button @click="popUps.popupCancelOrder=true; params.reference1=params.reference" class="ml-auto w-full" color="primary" type="filled">Cancel order</vs-button>
        </div>
        <div class="vx-col" v-if="buttons.completeDeposit && isUserAllowedBtn"> 
          <vs-button @click="popUps.popupCompleteDeposit=true" class="ml-auto w-full" color="primary" type="filled">Complete deposit</vs-button>
        </div>
        <div class="vx-col" v-if="buttons.sellComplete && isUserAllowedBtn"> 
          <vs-button @click="popUps.popupSellActive=true" class="ml-auto w-full" color="primary" type="filled">Sell complete</vs-button>
        </div>
        <div class="vx-col" v-if="buttons.sellCompleteManual && isUserAllowedBtn"> 
          <vs-button @click="popUps.popupSellManualActive=true" class="ml-auto w-full" color="primary" type="filled">Sell complete manual</vs-button>
        </div>
        <div class="vx-col" v-if="buttons.allowCapture && isUserAllowedBtn"> 
          <vs-button @click="popUps.popupCaptureActive=true" class="ml-auto w-full" color="primary" type="filled">Capture order</vs-button>
        </div>
        <div class="vx-col" v-if="buttons.buyButtons && isUserAllowedBtn"> 
          <vs-button @click="popUps.popupDeclineActive=true" class="ml-auto w-full" color="primary" type="filled">Decline</vs-button>
        </div>
        <div class="vx-col" v-if="buttons.buyButtons && isUserAllowedBtn"> 
          <vs-button @click="popUps.popupApproveOrder=true" class="ml-auto w-full" color="primary" type="filled">Approve</vs-button>
        </div>
        <div class="vx-col" v-if="approved && isUserAllowedBtn"> 
          <vs-button @click="popUps.popupUpdateRate=true" class="ml-auto w-full" color="primary" type="filled">Update rate</vs-button>
        </div>
      
        <div class="vx-col"> 
          <vs-button @click="goToClient" class="ml-auto w-full" color="primary" type="filled">Go To Client</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios.js"
import draggable from 'vuedraggable'
export default {
    data() {
        return {
           params:{amount:0},
           fieldsData:[],
           dataOrder: [],
           approved:false,
           amount_approved:0,
           wallet:null,
           popUps:{
            popupSettleActive: false,
            popupSendCrypto: false,
            popupUpdateRate:false,
            popupShowActive:false,
            popupActive:false,
            popupDeclineActive: false,
            popupApproveOrder: false,
            popupUpdateRefActive: false,
            popupCaptureActive: false,
            popupSellActive:false,
            popupSellManualActive: false,
            popupCompleteDeposit: false,
            popupCancelOrder: false,
           },
           buttons:{
             sellComplete: false,
             sellCompleteManual: false,
             completeDeposit: false,
             cancelOrder: false,
             completeManual: false,
             settle: false
           },
           isUserAllowedBtn: false
           
        }
    },
    components: {
      draggable,
  },
    computed:{
      amount:{
        get: function(){
          if(this.params.amount!==undefined)
            return this.formatNumber(this.params.amount);
          return false;
        },
        set: function(num){
          this.params.amount=num;
        }
      },
      showWindow(){
        if(this.$route.path.indexOf('/transaction/')!==-1){
          //if(this.fieldsData.length===0)
            this.setData();
          return true;
        }
        return false;
      },
    },
    mounted() {
       this.checkButtons()
    },
    methods: {
      checkButtons(){
        const userGroupStorage = localStorage.getItem('userInfo');
        if(!userGroupStorage){
          return false;
        }

        const userInfo = JSON.parse(userGroupStorage);
        
        if(userInfo.group!=='compliance'){
          this.isUserAllowedBtn=true
        }
      },

      goToClient(){
        try{
          const clientEmailObj = this.fieldsData.find(obj => obj.name ==='username');
          const clientIdObj = this.fieldsData.find(obj => obj.name ==='user_id');
          if(!clientEmailObj || !clientIdObj)
            return false;

          const clientEmail = clientEmailObj.value;
          const clientId = clientIdObj.value
          const where = `clients/${clientId}/${clientEmail}`
          window.open(location.origin+'/'+where, '_blank');
        }
        
        catch(e){
          console.log(e)
        }
      },
      showHideColumn: function(name){
          for(let i in this.dataOrder){
              if(this.dataOrder[i].name===name){
                this.dataOrder[i].show = !this.dataOrder[i].show;                
                for(let j in this.fieldsData){
                  if(this.fieldsData[j].name===this.dataOrder[i].name){
                    this.fieldsData[j].show = this.dataOrder[i].show;
                  }
                }
                break;
              }
          }
          localStorage.setItem('transactionDetails', JSON.stringify(this.fieldsData));
      },
      getType: function(name){
          for(let i in this.dataOrder){
              if(this.dataOrder[i].name===name){
                return this.dataOrder[i].show ? 'filled' : 'border';
              }
          }
          return 'filled';
      },
      saveSort: function(){
        this.drag=false;
        let counter = 1;
          for(let i in this.fieldsData){
            this.fieldsData[i].order = counter;
            counter++;
          }
          localStorage.setItem('transactionDetails', JSON.stringify(this.fieldsData));
      },
      loadState: function(){
          this.dataOrder = JSON.parse(localStorage.getItem('transactionDetails'));
      },
      formatNumber: function(num) {
        num = num.toString().split(',').join('');
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      },
      copyToClipBoard: function(index){
        let that = this;
        let text = this.params[index];
        let textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        if(document.execCommand('copy'))
              that.openAlert('success','','copied to clipboard');
        document.body.removeChild(textArea);
      },
      isReadOnly: function(index){
        return this.editable.indexOf(index)===-1;
      },
      setData: function(){
        this.loadState();
        const params = new URLSearchParams();
        params.append('uid', this.$route.params.userId);
        params.append('uname', this.$route.params.email);
        let that = this;
        axios.post("/api/transactions",params)
        .then((response) => {
          that.params = response.data;          
          if(response.data.initial_amount)
              that.params.amount = response.data.initial_amount.replace(' EUR','');
          let data = response.data;
          let counter = 1;          
          if(that.dataOrder!==null && that.dataOrder.length>0){
            for(let i in response.data){
              let order = that.dataOrder.length + counter;
              let show  = true;
              for(let j in that.dataOrder){
                if(that.dataOrder[j].name===i){
                  order = that.dataOrder[j].order;
                  if(!that.dataOrder[j].show)
                    show = that.dataOrder[j].show;
                  break;
                }
              }                              
              that.fieldsData.push({"name":i,"value":response.data[i],"order":order,"show":show})
              counter++;
            }
          } else{
            for(let i in response.data){
              that.fieldsData.push({"name":i,"value":response.data[i],"order":counter,"show":true})
              counter++;
            }
          }
        
          that.fieldsData.sort(function(a, b) {
            var x = a.order, y = b.order;
            // Compare the 2 dates
            if (x < y) return -1;
            if (x > y) return 1;
            return 0;
          });
          that.amount_approved = 0;
          that.wallet = null;
          const amountObj = that.fieldsData.find(o => o.name === 'amount');
          if(amountObj)
            amountObj.show=false;
          switch(data.status){
            case 'approved':
              that.$set(that.params,'value_out',response.data.value_approved.replace(' BTC',''));
              
              that.approved = true;
              that.amount_approved = response.data.amount_approved.replace(' EUR','');
              that.wallet = that.params.wallet;
              if (data.type === 'buy')
                that.buttons.completeManual = true;
                that.buttons.settle = true;
                //that.params.amount = parseFloat(that.amount_approved.replace('/,/g',''));
              
            break;
            case 'initiated':
              that.buttons.cancelOrder = true;
              
            break;
            case 'pending payment':{
              that.buttons.cancelOrder = true;
              if (data.type === 'buy')
                that.buttons.buyButtons = true;
            break;
            }



          }
          
           
          /*
          if (data.status !== 'processed' && data.status !== 'approved') {
              that.buttons.cancelOrder = true;
                if (data.type === 'buy') {
                    that.buttons.buyButtons = true;
                    if(data.status=='pending approval'){
                        that.buttons.allowCapture = true;
                    }
                } else if (data.type === 'sell') {
                    if(data.status==='pending approval'){   
                        that.buttons.sellComplete = true;
                    } else if(data.status==='unprocessed'){
                        that.buttons.sellCompleteManual = true;
                    }
                }
            } else if (data.type === 'buy' && data.status === 'approved') {
                that.buttons.completeManual = true;
            }
            */
        })
        .catch(() => {  })
      },
      reset: function(){
        this.approved=false;
        this.amount_approved=0;
        this.wallet=null;
        this.popUps={
          popupShowActive: false,
          popupActive:false,
          popupSettleActive: false,
          popupSellActive:false,
          popupSellManualActive: false,
          popupCompleteDeposit: false,
          popupCancelOrder: false,
        }
        this.buttons={
          sellComplete: false,
          sellCompleteManual: false,
          completeDeposit: false,
          cancelOrder: false
        }
      },
      sendData: function(type){
        let that = this;
        const params = new URLSearchParams();
        params.append('type', type);
        switch(type){
          case 'complete-deposit':
              params.append('email', this.params.username);
              params.append('wallet', this.params.wallet);
              params.append('wire_ref', this.params.reference);
              params.append('amount', (this.params.amount).replace(',',''));
              break;
          case 'send-wallet':
              
              params.append('wire_ref', this.params.reference);
              break;
          case 'cancel-order':
              params.append('email', this.params.username);
              params.append('reference1', this.params.reference);
              break;
          case 'decline':
          case 'capture':
              params.append('email', this.params.username);
              params.append('wire_ref', this.params.reference);
              break;
            case 'approve':
              params.append('amount', (this.params.amount).replace(',',''));
              params.append('email', this.params.username);
              params.append('wire_ref', this.params.reference);
              break; 
            case 'wire-ref-update':
              params.append('transaction_id', this.params.transaction_id);
              params.append('email', this.params.username);
              params.append('trans_ref', this.params.psp_reference);
              break;
            case 'complete-manual':
              params.append('wire_ref', this.params.reference);
              params.append('commission', this.params.commission);
              params.append('amount', (this.params.amount).replace(',',''));
              params.append('value_out', this.params.value_out);
              params.append('ext_ref', this.params.ext_ref);
              params.append('send_code', this.params.send_code);
              break;
            case 'updateRate':
              params.append('ref', this.params.reference);
              params.append('wallet', this.wallet);
              params.append('amount', this.amount_approved);
              break;
            case 'sendCrypto':
              params.append('ref', this.params.reference);
              break;
        }
        this.$vs.loading();
        axios.post("/api/transaction",params)
        .then((data) => {          
          that.$vs.loading.close();
          if(data.data[0].out1==='done!'){
            that.popupActive = false;
            that.popupSettleActive = false;
            that.params = {amount: 0};
            that.openAlert('success','Success',data.data[0].out1);
            that.reset();
            that.setData(true);
          } else{
            that.openAlert('danger','Failed',data.data[0].out1);
          }
        })
        .catch((error) => { that.$vs.loading.close(); that.openAlert('danger','Failed',error.data[0].out1); })
      },
      openAlert(color,title,text) {
      let colorAlert = color;
      this.$vs.notify({
          title: title,
          text: text,
          color: colorAlert
      })
    },
   
    }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }

  .send-wallet-val-input /deep/ input {
    font-weight: bold;
  }

  
}
/*! rtl:end:ignore */
</style>
